import { Button, VStack } from '@chakra-ui/react';
import { useState } from 'react';

import { JsonReadonlyBlock } from '#components/json-readonly-block';

const DEFAULT_COLLAPSED_HEIGHT = '96px';

interface CollapsibleJsonReadonlyBlockProps {
  title: string;
  value: unknown;
  collapsedHeight?: string;
  /** Upper bound for expanded editor height (pixels). */
  maxExpandedContentHeightPx?: number;
}

export function CollapsibleJsonReadonlyBlock({
  title,
  value,
  collapsedHeight = DEFAULT_COLLAPSED_HEIGHT,
  maxExpandedContentHeightPx,
}: CollapsibleJsonReadonlyBlockProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <VStack gap={1} align="stretch">
      <JsonReadonlyBlock
        title={title}
        value={value}
        height={collapsedHeight}
        fitContentHeight={expanded}
        maxContentHeightPx={maxExpandedContentHeightPx}
      />
      <Button
        type="button"
        size="xs"
        variant="ghost"
        alignSelf="flex-start"
        aria-expanded={expanded}
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? 'Collapse' : 'Expand'}
      </Button>
    </VStack>
  );
}
